import { useMemo } from 'react';

export const useDisabledTabs = (clusterId, hasValidInput) => {
  const disabledTabs = useMemo(() => {
    const hasCluster = Boolean(clusterId);
    const isOutputEventDisabled = !hasCluster || !hasValidInput;

    let disabledMessage = '';
    if (!hasCluster && !hasValidInput) {
      disabledMessage = 'Please select a cluster and provide a valid input event to enable the output tab';
    } else if (!hasCluster) {
      disabledMessage = 'Please select a cluster to enable the output tab';
    } else if (!hasValidInput) {
      disabledMessage = 'Please provide a valid input event to enable the output tab';
    }

    return {
      outputEvent: {
        disabled: isOutputEventDisabled,
        disabledMessage,
      },
    };
  }, [clusterId, hasValidInput]);

  return disabledTabs;
};
